<template>
  <article>
    <div class="align">
      <h1>Займ до 100 тысяч рублей без кредитной истории</h1>

      <ul>
        <li>
          <div>
            <IconBase :viewBox="'0 0 28 28'">
              <frstA></frstA>
            </IconBase>
          </div>
          <span>Сумма займа до 100 000 руб.</span>
        </li>
        <li>
          <div>
            <IconBase :viewBox="'0 0 28 28'">
              <frstA></frstA>
            </IconBase>
          </div>
          <span>Срок займа до 1-го года</span>
        </li>
        <li>
          <div>
            <IconBase :viewBox="'0 0 28 28'">
              <frstA></frstA>
            </IconBase>
          </div>
          <span>Высокая вероятность одобрения</span>
        </li>
      </ul>

      <frstScreenFormStart></frstScreenFormStart>
    </div>
  </article>
</template>

<script>
  export default {
    name: "frstScreen",
    components: {
      frstScreenFormStart: () => import('@/components/section/frstScreenFormStart'),
      frstA: () => import('@/components/svg/frstA'),
      IconBase: () => import('@/components/svg/IconBase'),
    }
  }
</script>

<style scoped>

  article
  {color: white;background-image: url("../../assets/images/frstScreenBdMob.jpg");background-repeat: no-repeat;background-position: top center;;background-size: 100vw;}
  h1 {font-size: 7vw;padding: 5.4vw 0 2.5vw;}
  article .align {display: flex;flex-direction: column;justify-content: flex-start}
  ul{}
  li{display: flex;align-items: center;padding-bottom: 4vw;}
  li > div {width: 7.5vw;height: 7.5vw;margin-right: 1.4vw;}
  li > span {font-size: 4.8vw;}
  li > div > svg {fill:#42AB34}

  @media screen and (min-width: 760px) {
    article {background-image: url("../../assets/images/frsScreenBg.jpg");background-position: center center;background-repeat: no-repeat;background-size: cover;height: 46.7vw}
    article .align {height: 100%;justify-content: flex-end}
    .align{width: 90.1vw;}
    ul {display: flex;padding: 4vw 0;}
    li {margin-right: 60px;padding: 0;}
    li > div {width: 2.5vw;height: 2.5vw;margin-right: 1.4vw;}
    li > span {font-size: 1.6vw;}
    h1 {font-size: 3.6vw;padding: 0;}
  }
  @media screen and (min-width: 1140px) {
    article {height: 532px}
    ul {padding: 45px 0}
    li {margin-right: 60px;}
    li > div {width: 28px;height: 28px;margin-right: 15px;}
    li > span {font-size: 18px}
    h1 {font-size: 40px;}
  .align{width:1120px}
  }
</style>
